import { css, Theme } from '@emotion/react'
import { typography } from '@/styles'

export const styles = (theme: Theme) => ({
  stat: {
    main: css``,
    count: css`
      font-size: ${typography.h6};
      font-weight: bold;
      color: ${theme.colors.secondary.normal};
    `,
    name: css`
      font-size: ${typography.sp};
    `,
  },
})
